import React from 'react';

import {Anchor, Dialogue, Button, Text} from '@albert-io/atomic';

interface Props {
  className: string;
  handleClose: () => void;
  syncClassroom: () => void;
}

const ImportRosterError = ({className, handleClose, syncClassroom}: Props) => (
  <Dialogue hideCloseBtn className={className} size='m' title='An error occured.'>
    <Dialogue.Body>
      <div className='u-display_flex u-flex-direction_column'>
        <Text>
          We could not import your roster at this time. Make sure you follow the instructions in our{' '}
          <Anchor href='https://help.albert.io/en/articles/5350870-how-do-i-use-canvas-on-albert-as-a-teacher#h_3303c5848e'>
            help article
          </Anchor>
          . If the error persists, contact our support team through the chat widget below or by{' '}
          <Anchor href='mailto:success@albert.io'>email</Anchor>.
        </Text>
      </div>
    </Dialogue.Body>
    <Dialogue.BtnGroup>
      <Button color='secondary' onClick={() => handleClose()}>
        Cancel
      </Button>
      <Button onClick={() => syncClassroom()}>Try again</Button>
    </Dialogue.BtnGroup>
  </Dialogue>
);

export default ImportRosterError;
